var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewManageMonitors01 = function SvgViewManageMonitors01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 13.58,
    y1: 181.28,
    x2: 200.31,
    y2: 5.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -64.78,
    y1: 97.97,
    x2: 121.95,
    y2: -77.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -56.96,
    y1: 106.29,
    x2: 129.77,
    y2: -69.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -49.13,
    y1: 114.61,
    x2: 137.6,
    y2: -61.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 8.76,
    y1: 176.16,
    x2: 195.49,
    y2: 0.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -29.75,
    y1: 135.21,
    x2: 156.98,
    y2: -40.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -25.84,
    y1: 139.37,
    x2: 160.89,
    y2: -36.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.8,
    y1: 161.74,
    x2: 181.93,
    y2: -13.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.89,
    y1: 165.9,
    x2: 185.84,
    y2: -9.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 20.15,
    y1: 188.27,
    x2: 206.88,
    y2: 12.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 24.06,
    y1: 192.43,
    x2: 210.79,
    y2: 16.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.76,
    y1: 167.65,
    x2: 187.49,
    y2: -7.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 25.71,
    y1: 194.18,
    x2: 212.44,
    y2: 18.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 50.66,
    y1: 220.71,
    x2: 237.39,
    y2: 45.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 22,
    y1: 190.23,
    x2: 208.73,
    y2: 14.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 46.95,
    y1: 216.76,
    x2: 233.68,
    y2: 41.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 71.9,
    y1: 243.29,
    x2: 258.63,
    y2: 67.67,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M190,0H10C4.48,0,0,4.48,0,10v180c0,5.52,4.48,10,10,10h180c5.52,0,10-4.48,10-10V10c0-5.52-4.48-10-10-10ZM6.67,10c0-1.84,1.49-3.33,3.33-3.33h180c1.84,0,3.33,1.49,3.33,3.33v16.67H6.67V10ZM193.33,190h0c0,1.84-1.49,3.33-3.33,3.33H10c-1.84,0-3.33-1.49-3.33-3.33V33.33h186.67v156.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.33,13.33h-3.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h3.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M40,13.33h-3.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h3.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.67,13.33h-3.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h3.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M180,13.33h-3.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h3.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M26.67,83.33h40c5.52,0,10-4.48,10-10v-20c0-5.52-4.48-10-10-10H26.67c-5.52,0-10,4.48-10,10v20c0,5.52,4.48,10,10,10ZM40,50h26.67c1.84,0,3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33h-26.67v-26.67ZM26.67,50h6.67v26.67h-6.67c-1.84,0-3.33-1.49-3.33-3.33v-20h0c0-1.84,1.49-3.33,3.33-3.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M60,60h-10c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h10c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.67,133.33h40c5.52,0,10-4.48,10-10v-20c0-5.52-4.48-10-10-10H26.67c-5.52,0-10,4.48-10,10v20c0,5.52,4.48,10,10,10ZM40,100h26.67c1.84,0,3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33h-26.67v-26.67ZM26.67,100h6.67v26.67h-6.67c-1.84,0-3.33-1.49-3.33-3.33v-20h0c0-1.84,1.49-3.33,3.33-3.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M60,110h-10c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h10c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.67,183.33h40c5.52,0,10-4.48,10-10v-20c0-5.52-4.48-10-10-10H26.67c-5.52,0-10,4.48-10,10v20c0,5.52,4.48,10,10,10ZM40,150h26.67c1.84,0,3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33h-26.67v-26.67ZM26.67,150h6.67v26.67h-6.67c-1.84,0-3.33-1.49-3.33-3.33v-20h0c0-1.84,1.49-3.33,3.33-3.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M60,160h-10c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33h10c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90,66.67h43.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-43.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90,116.67h43.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-43.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90,166.67h43.33c1.84,0,3.33-1.49,3.33-3.33s-1.49-3.33-3.33-3.33h-43.33c-1.84,0-3.33,1.49-3.33,3.33s1.49,3.33,3.33,3.33Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.31,72.36c1.3,1.3,3.41,1.3,4.71,0l16.67-16.67c1.26-1.31,1.25-3.39-.04-4.67-1.29-1.29-3.36-1.3-4.67-.04l-14.31,14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04-1.29,1.29-1.3,3.36-.04,4.67l6.67,6.67Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M154.31,122.36c1.3,1.3,3.41,1.3,4.71,0l16.67-16.67c1.26-1.31,1.25-3.39-.04-4.67-1.29-1.29-3.36-1.3-4.67-.04l-14.31,14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04-1.29,1.29-1.3,3.36-.04,4.67l6.67,6.67Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M154.31,172.36c1.3,1.3,3.41,1.3,4.71,0l16.67-16.67c1.26-1.31,1.25-3.39-.04-4.67-1.29-1.29-3.36-1.3-4.67-.04l-14.31,14.31-4.31-4.31c-1.31-1.26-3.39-1.25-4.67.04-1.29,1.29-1.3,3.36-.04,4.67l6.67,6.67Z"
  })));
};
export default SvgViewManageMonitors01;